import { locales } from "src/i18n";
import { currentLocale } from "src/i18n/hosts";
import { DictionaryKey } from "src/types/language";

/**
 * Перевод БЕЗ React-контекста.
 *
 * Нужен там, где `useIntl()` недоступен или нежелателен: тексты тостов в
 * query-хуках (вызываются из колбэков react-query), утилиты-форматтеры,
 * классовый ErrorBoundary (он намеренно самодостаточен и не должен зависеть
 * от провайдеров, иначе фолбэк не отрисуется при падении именно в них).
 *
 * Локаль определяется доменом и фиксируется один раз за загрузку страницы
 * (см. src/i18n/hosts.ts) — тот же словарь, что отдаётся в IntlProvider,
 * поэтому тексты здесь и в `<Msg />` всегда совпадают.
 */
const dictionary = locales[currentLocale].dictionary as Record<string, string>;

export const t = (
  id: DictionaryKey,
  values?: Record<string, string | number>,
): string => {
  const template = dictionary[id] ?? id;

  if (!values) {
    return template;
  }

  // Простая подстановка `{name}` — ICU-разметка (plural/select) в этих
  // строках не используется, полноценный formatMessage здесь не нужен.
  return Object.keys(values).reduce(
    (acc, key) => acc.split(`{${key}}`).join(String(values[key])),
    template,
  );
};
